import { forwardRef } from "react";
import Typography from "@mui/material/Typography";
import PropTypes from "prop-types";

const colorMap = {
  dark: "text.primary",
  light: "text.secondary",
  white: "#fff",
  text: "text.primary",
  inherit: "inherit",
};

const PointieTypography = forwardRef(
  ({ color, fontWeight, textTransform, verticalAlign, opacity, children, ...rest }, ref) => {
    const sx = { ...rest.sx };

    if (fontWeight) sx.fontWeight = fontWeight;
    if (textTransform && textTransform !== "none") sx.textTransform = textTransform;
    if (verticalAlign && verticalAlign !== "unset") sx.verticalAlign = verticalAlign;
    if (opacity !== undefined && opacity !== 1) sx.opacity = opacity;
    if (!sx.textDecoration) sx.textDecoration = "none";

    const mappedColor = colorMap[color] || (color ? `${color}.main` : undefined);

    return (
      <Typography ref={ref} {...rest} color={mappedColor} sx={sx}>
        {children}
      </Typography>
    );
  }
);

PointieTypography.displayName = "PointieTypography";
PointieTypography.propTypes = {
  color: PropTypes.string,
  fontWeight: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  textTransform: PropTypes.string,
  verticalAlign: PropTypes.string,
  opacity: PropTypes.number,
  children: PropTypes.node,
};
export default PointieTypography;
